// @flow

import type {
  QuickStartGuidesState,
  QuickStartGuidesAction
} from 'stores/flow-type/dashboard/quick-start-guide.type';

import {
  GET_QUICK_START_GUIDES_REQUEST,
  GET_QUICK_START_GUIDES_SUCCESS,
  GET_QUICK_START_GUIDES_FAILURE,
  MARK_DONE_STEP_REQUEST,
  MARK_DONE_STEP_SUCCESS,
  MARK_DONE_STEP_FAILURE,
  GUIDE_SEND_FEEDBACK_REQUEST,
  GUIDE_SEND_FEEDBACK_SUCCESS,
  GUIDE_SEND_FEEDBACK_FAILURE
} from 'stores/flow-type/dashboard/quick-start-guide.type';

const initialState: QuickStartGuidesState = {
  loading: false,
  success: false,
  error: undefined,
  steps: [],
  step: {},
  updating: false,
  updateSuccess: false,
  sendingFeedbackFilter: false,
  sendingFeedbackSearch: false,
  sendingFeedbackRecommend: false,
  sendFeedbackFilterSuccess: false,
  sendFeedbackSearchSuccess: false,
  sendFeedbackRecommendSuccess: false,
  sendFeedbackGuideSuccess: false
};

const OptionEmailReducers = (
  state: QuickStartGuidesState = initialState,
  action: QuickStartGuidesAction
) => {
  switch (action.type) {
    case GET_QUICK_START_GUIDES_REQUEST:
      return { ...state, loading: true };
    case GET_QUICK_START_GUIDES_SUCCESS: {
      const { data } = action.payload;
      return { ...state, loading: false, success: true, steps: data };
    }
    case GET_QUICK_START_GUIDES_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    case MARK_DONE_STEP_REQUEST:
      return { ...state, updating: true };
    case MARK_DONE_STEP_SUCCESS: {
      const { data } = action.payload;
      return { ...state, updating: false, updateSuccess: true, step: data };
    }
    case MARK_DONE_STEP_FAILURE:
      return {
        ...state,
        updating: false,
        updateSuccess: false,
        error: action.payload
      };
    case GUIDE_SEND_FEEDBACK_REQUEST: {
      const { feature } = action.payload;
      return { ...state, [`sendingFeedback${feature}`]: true, sendFeedbackGuideSuccess: false };
    }
    case GUIDE_SEND_FEEDBACK_SUCCESS: {
      const { data, feature } = action.payload;
      return {
        ...state,
        [`sendingFeedback${feature}`]: false,
        [`sendFeedback${feature}Success`]: true,
        sendFeedbackGuideSuccess: true,
        step: data
      };
    }
    case GUIDE_SEND_FEEDBACK_FAILURE: {
      const { feature } = action.payload;
      return {
        ...state,
        [`sendingFeedback${feature}`]: false,
        [`sendFeedback${feature}Success`]: false,
        sendFeedbackGuideSuccess: false,
        error: action.payload
      };
    }
    default:
      return state;
  }
};

export default OptionEmailReducers;
